import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SharedModule } from 'src/app/shared.module'
import { TopBarComponent } from './top-bar/top-bar.component'
import { TopbarUserMenuComponent } from './top-bar/user-menu/user-menu.component'
import { MenuLeftComponent } from './menus/menu-left/menu-left.component'
import { MenuTopComponent } from './menus/menu-top/menu-top.component'
import { FooterComponent } from './footers/footer.component'
import { MenuTopSecondComponent } from './menus/menu-top-second/menu-top-second.component'
import { PlantNameComponent } from './top-bar/plant-name/plant-name.component'
import { LicenseNotificationComponent } from './license-notification/license-notification.component'
import { WeatherStatusComponent } from './top-bar/weather-status/weather-status.component'
import { NgScrollbarModule } from 'ngx-scrollbar'
import { NgOptimizedImage } from '@angular/common'
import { CopyUrlComponent } from "./top-bar/copy-url/copy-url.component"

const COMPONENTS = [
  TopBarComponent,
  TopbarUserMenuComponent,
  MenuLeftComponent,
  MenuTopComponent,
  FooterComponent,
  MenuTopSecondComponent,
  LicenseNotificationComponent,
  PlantNameComponent,
  WeatherStatusComponent,
  CopyUrlComponent
]

@NgModule({
  imports: [SharedModule, FormsModule, ReactiveFormsModule, NgScrollbarModule, NgOptimizedImage],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class LayoutModule {}
